import { beginnerDeviceField } from '../devices/device-selector.js';
import type { BeginnerDeviceKind } from '../devices/types.js';

/** Shared Blockly style for all beginner display blocks. */
export const BEGINNER_DISPLAY_BLOCK_STYLE = 'beginner_display_blocks';

/** Connection modes for 16x2 LCD. */
export const LCD_CONNECTION_PARALLEL = 'PARALLEL';
export const LCD_CONNECTION_I2C = 'I2C';

/** Reusable device dropdown for OLED / TFT (LCD uses a single display). */
export function displayDeviceField(kind: BeginnerDeviceKind, name = 'DEVICE') {
  return beginnerDeviceField(name, kind);
}

/** Column / row cursor fields shared by LCD, OLED, and TFT. */
export function displayCursorFields(
  columnDefault = 0,
  rowDefault = 0,
): Array<Record<string, unknown>> {
  return [
    {
      type: 'field_number',
      name: 'COLUMN',
      value: columnDefault,
      min: 0,
      precision: 1,
    },
    {
      type: 'field_number',
      name: 'ROW',
      value: rowDefault,
      min: 0,
      precision: 1,
    },
  ];
}

/** Text value input (shadowed with text in the toolbox). */
export function displayTextValueInput(name = 'TEXT') {
  return { type: 'input_value', name, check: 'String' };
}
